var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJsFunction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14645 6.14645C8.34171 5.95118 8.65829 5.95118 8.85355 6.14645L10.5 7.79289L12.1464 6.14645C12.3417 5.95118 12.6583 5.95118 12.8536 6.14645C13.0488 6.34171 13.0488 6.65829 12.8536 6.85355L11.2071 8.5L12.8536 10.1464C13.0488 10.3417 13.0488 10.6583 12.8536 10.8536C12.6583 11.0488 12.3417 11.0488 12.1464 10.8536L10.5 9.20711L8.85355 10.8536C8.65829 11.0488 8.34171 11.0488 8.14645 10.8536C7.95118 10.6583 7.95118 10.3417 8.14645 10.1464L9.79289 8.5L8.14645 6.85355C7.95118 6.65829 7.95118 6.34171 8.14645 6.14645Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 3C7.11929 3 6 4.11929 6 5.5V9.5C6 11.433 4.433 13 2.5 13H1.5C1.22386 13 1 12.7761 1 12.5C1 12.2239 1.22386 12 1.5 12H2.5C3.88071 12 5 10.8807 5 9.5V5.5C5 3.567 6.567 2 8.5 2C8.77614 2 9 2.22386 9 2.5C9 2.77614 8.77614 3 8.5 3Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6.5C2 6.22386 2.22386 6 2.5 6H8.5C8.77614 6 9 6.22386 9 6.5C9 6.77614 8.77614 7 8.5 7H2.5C2.22386 7 2 6.77614 2 6.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJsFunction);
export default __webpack_public_path__ + "static/media/js-function.42bf697c39efda2bbbd0c91340d447c3.svg";
export { ForwardRef as ReactComponent };